import axios from '~/axiosWrapper';
import { API } from '~/app/routes';
import { fetch } from '~/store/commonStore';
import { Project } from '~/types';
import { assertOnlineForRemote } from './remoteGuard';

export type ProjectFavoritePayload = {
  projectId: Project['id'];
  favorite: boolean;
};

export type ProjectLastUsedPayload = {
  projectId: Project['id'];
};

export class ProjectRemoteDataSource {
  fetchProject(id: Project['id']): Promise<Project> {
    assertOnlineForRemote();
    return axios.get(`${API.projects}/${id}`);
  }

  fetchLastUsed(): Promise<Project[]> {
    assertOnlineForRemote();
    return fetch<Project>(`${API.projects}/last-used`);
  }

  fetchFavorites(): Promise<Project[]> {
    assertOnlineForRemote();
    return fetch<Project>(`${API.projects}/favorite`);
  }

  updateFavorites(payload: ProjectFavoritePayload): Promise<null> {
    assertOnlineForRemote();
    return axios.patch(`${API.projects}/favorite`, payload);
  }

  updateLastUsed(payload: ProjectLastUsedPayload): Promise<null> {
    assertOnlineForRemote();
    return axios.post(`${API.projects}/last-used`, payload);
  }
}

export const projectRemote = new ProjectRemoteDataSource();
